export default __webpack_public_path__ + "static/media/IMG-20210326-WA0030.3295bd38.jpg";